import { forwardRef, type HTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

/**
 * Grid — адаптивная сетка (`.grid2` макета). Двух/трёхколоночные блоки сворачиваются в одну колонку
 * ниже контрольной точки breakpoint из токенов. Порог — только из токена (без жёстких px).
 * Адаптив набора из 4 счётчиков (4→2) — НЕ здесь, это StatGrid.
 */
export interface GridProps extends HTMLAttributes<HTMLDivElement> {
  cols?: 2 | 3
}

const COLS: Record<NonNullable<GridProps['cols']>, string> = {
  2: 'nw:grid-cols-2',
  3: 'nw:grid-cols-3',
}

export const Grid = forwardRef<HTMLDivElement, GridProps>(
  ({ className, cols = 2, ...props }, ref) => (
    <div ref={ref} className={cn('grid grid-cols-1 gap-4', COLS[cols], className)} {...props} />
  ),
)
Grid.displayName = 'Grid'
